var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtt01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3072_83796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3668 11.452C31.2059 13.453 32.8589 15.0297 34.9129 15.7696L37.5593 19.2632L40.2056 15.7696C43.2071 14.6883 45.3527 11.8201 45.3527 8.45166C45.3527 4.15614 41.8634 0.673974 37.5593 0.673974C33.255 0.673974 29.7659 4.15614 29.7659 8.45166",
    stroke: "#457ABD",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2808 8.49365H35.9329V5.24481H38.2808C39.1779 5.24481 39.9052 5.9721 39.9052 6.86928C39.9052 7.76637 39.1779 8.49365 38.2808 8.49365Z",
    stroke: "#457ABD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2808 11.7424H35.9329V8.49359H38.2808C39.1779 8.49359 39.9052 9.22088 39.9052 10.118V10.1181C39.9052 11.0151 39.1779 11.7424 38.2808 11.7424Z",
    stroke: "#457ABD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6861 31.5143C14.5094 28.7084 11.7322 26.7369 8.49363 26.7369C4.18949 26.7369 0.700317 30.2191 0.700317 34.5147C0.700317 37.883 2.84579 40.7512 5.84729 41.8325L8.49363 45.3262L11.14 41.8325C14.1417 40.7512 16.287 37.883 16.287 34.5147",
    stroke: "#457ABD",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4798 35.1382H6.50752V33.1543C6.50752 32.0588 7.39572 31.1706 8.49127 31.1706H8.49603C9.59159 31.1706 10.4798 32.0588 10.4798 33.1543V35.1382Z",
    stroke: "#457ABD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50752 37.6682V35.1382H10.4798V37.6682",
    stroke: "#457ABD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2735 38.1445H30.2864C34.3105 38.1445 37.5728 34.8823 37.5728 30.8582C37.5728 26.834 34.3105 23.5718 30.2864 23.5718H15.7136C11.6895 23.5718 8.42722 20.3096 8.42722 16.2855C8.42722 12.2613 11.6895 8.99913 15.7136 8.99913H26.2344",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3072_83796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtt01);
export default __webpack_public_path__ + "static/media/OTT01.0ada589954b6edd2d3c16fb02fdcdb55.svg";
export { ForwardRef as ReactComponent };